import tabNames from './tabNames';

export default [tabNames.details, tabNames.analytics, tabNames.accessibility, tabNames.quizzing];